/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react' //, {useState}
import UsersCrud from '../../modules/custom/accounts/userss/UsersTable'

const Users: React.FC = () => {


  return (
    <>
      {/*<div className="d-flex flex-column-auto h-60px bg-info-td border-rounded flex-center border rounded">
        <h3 className='f-titulo fs-md text-w'> Users List</h3>
  </div>*/}
      <div  className='card mb-5 mb-xl-5'>
          <UsersCrud></UsersCrud>
      </div>
    </>
  )
}

export {Users}
